/**
 * CustomerAvatar — small image/initials badge for customer list rows.
 */
import React from "react";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

function initials(name) {
  if (!name) return "?";
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
}

export default function CustomerAvatar({ customer, size = "md", testId }) {
  const photo = customer?.documents?.photo;
  const dim =
    size === "xl"
      ? "w-20 h-20 text-2xl"
      : size === "lg"
      ? "w-12 h-12 text-base"
      : size === "sm"
      ? "w-8 h-8 text-xs"
      : "w-10 h-10 text-sm";
  if (photo) {
    return (
      <img
        src={`${API_BASE}${photo}`}
        alt={customer?.name || "Customer"}
        className={`${dim} rounded-full object-cover border border-slate-200`}
        data-testid={testId}
      />
    );
  }
  return (
    <div
      className={`${dim} rounded-full bg-gradient-to-br from-emerald-500 to-emerald-700 text-white font-bold flex items-center justify-center border border-emerald-700/30`}
      data-testid={testId}
    >
      {initials(customer?.name)}
    </div>
  );
}
